<template>
    <main id="home-wrapper">
        <div v-if="loadernews" class="loading loading-double"></div>
        <div v-else id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url, status: false },
                    { title: 'News', url: app_url+'/news', status: true },
                    { title: newsDetail.title, url: app_url+'/news-detail', status: true }
                ]"
            ></breadcrumb>
            <section id="detail-news" class="section withPad" v-if="newsDetail">
                <div class="container">
                    <div class="row-grid">
                        <div class="col-grid-60">
                            <div class="item_detail_news">
                                <div class="title_main_news">
                                    <div class="wrap-label flex flex-center">
                                        <span><img :src="base_url+'/images/icon_calendar.png'" alt="calendar" /></span>
                                        <p class="tx-grey date-post">
                                            {{ newsDetail.date }}
                                        </p>
                                    </div>
                                    <div class="title-promo">
                                        <h2 class="tx-black">
                                            {{ newsDetail.title }}
                                        </h2>
                                        <p class="sub_community">
                                            {{
                                                newsDetail.club
                                                    ? newsDetail.club.name
                                                    : newsDetail.domain
                                                    ? newsDetail.domain
                                                    : "N/A"
                                            }}
                                        </p>

                                        <div
                                            class="btn-share"
                                            :class="{ active: show }"
                                        >
                                            <span class="shareTeks">Share</span>
                                            <div class="shares">
                                              <ShareNetwork
                                                  network="facebook"
                                                  @open="gtmTrackerShare(newsDetail,'Article Share', newsDetail.title, 'Facebook', 1,
                                                    'https://facebook.com/sharer/sharer.php?u='+ newsDetail.detail_url_web + '&title=' + newsDetail.title + '&description=' + newsDetail.summary)"
                                                  :url="newsDetail.detail_url_web"
                                                  :title="newsDetail.title"
                                                  :description="newsDetail.summary"
                                                >
                                                <i class="ion-social-facebook"></i>
                                              </ShareNetwork>
                                              <ShareNetwork
                                                  network="twitter"
                                                  @open="gtmTrackerShare(newsDetail,'Article Share', newsDetail.title, 'Twitter', 2,
                                                    'https://twitter.com/intent/tweet?text='+ newsDetail.title +'&url='+ newsDetail.detail_url_web)"
                                                  :url="newsDetail.detail_url_web"
                                                  :title="newsDetail.title"
                                                  :description="newsDetail.summary"
                                                >
                                                <i class="ion-social-twitter"></i>
                                              </ShareNetwork>
                                              <ShareNetwork
                                                  network="whatsapp"
                                                  @open="gtmTrackerShare(newsDetail,'Article Share', newsDetail.title, 'Whatsapp', 3,
                                                              'https://api.whatsapp.com/send?text='+ newsDetail.title + newsDetail.detail_url_web)"
                                                  :url="newsDetail.detail_url_web"
                                                  :title="newsDetail.title"
                                                  :description="newsDetail.summary"
                                                >
                                                <i class="ion-social-whatsapp"></i>
                                              </ShareNetwork>
                                            </div>
                                            <a
                                                @click="showShare"
                                                class="sharebtn"
                                                ><span
                                                    ><i
                                                        class="ion-android-share-alt"
                                                    ></i></span
                                            ></a>
                                        </div>
                                    </div>
                                </div>
                                <!--end.title_main_news-->
                                <div class="news-description"  v-html="newsDetail.description">
                                </div>
                            </div>
                            <!--end.item_detail_news-->
                            <div class="related_rows">
                                <RelatedVertical :relatedNews="relatedNews" @nextPage="getRelatedNews()"></RelatedVertical>
                            </div>
                        </div>

                        <div class="col-grid-40">
                            <SosokBrader></SosokBrader>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import NewsCard from "../news/NewsCard";
import EventCard from "../../widget/EventCard";
import SosokBrader from "../news/SosokBrader";
import RelatedVertical from "../news/RelatedVertical";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide,
        breadcrumb: BreadCrumb,
        NewsCard,
        SosokBrader,
        RelatedVertical,
        EventCard
    },
    data() {
        return {
            base_url:base_url,
            app_url:app_url,
            api_url:api_url,
            show: false,
            showDummy: false,
            mobile: false,
            tlength: 25,
            newsDetail: null,
            relatedNews: null,
            loadernews:true,
        };
    },
    created() {
        this.mobile = isMobile;
        this.getNewsDetail();
        console.log('oke')
    },
    mounted() {},
    methods: {
        // GTM Tracker
        gtmTrackerShare(data,action, title, lable, position, url) {
            var track = {
                'event': 'articleEngagement',
                'eventDetail.category': 'Article Engagement',
                'eventDetail.action': action,
                'eventDetail.label': lable,
                'position': position,
                'title': title,
                'articleId': data.id,
                'articlePublishedDate': data.date,
                'articleAuthor': data.club ? data.club : (data.domain ? data.domain : "N/A"),
                'destinationPageUrl': url
            };
            console.log(track);
            dataLayer.push(track)
        },
        // End GTM Tracker
        showShare() {
            this.show = !this.show;
            console.log(this.show);
        },
        getNewsDetail() {
          let route = api_url+`/news-detail?slug=${this.$route.query.slug}`;
          axios
              .get(route)
              .then(res => {
                  console.log(res);
                  if (res.status == 200) {
                      if (res?.data?.status) {
                          this.newsDetail = res?.data?.data?.newsDetail;
                          console.log(this.newsDetail);
                          this.loadernews = false;
                          if(this.newsDetail){
                            this.getRelatedNews();
                          }
                      }
                  }
              })
              .catch(err => {
                  console.log(err);
              });
        },
        getRelatedNews() {
          let route = api_url+`/news-related?tag=${this.newsDetail.tag}`;
          if(this.relatedNews?.nextPageUrl){
            route = this.relatedNews?.nextPageUrl;
          }
          axios
              .get(route)
              .then(res => {
                  console.log(res);
                  if (res.status == 200) {
                      if (res?.data?.status) {
                          this.relatedNews = res?.data?.data;
                      }
                  }
              })
              .catch(err => {
                  console.log(err);
              });
        },
    }
};
</script>

<style scoped lang="scss">
.img-promo-section {
    border-radius: 0px;
    overflow: hidden;
    img {
        width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share {
    margin-left: auto;
}
.shareTeks {
    display: inline-block;
    font-size: 14px;
    color: #fff;
    margin-right: 10px;
}
.btn-share a {
    font-size: 12px;
    padding-top: 3px;
    margin-top: auto;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 25px;
    height: 25px;
    line-height: auto;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 80px;
}
.active .shares {
    width: 108px;
    top: 1px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.news-description {
    img{
        width: 100%; height: auto !important;
    }
}
@media all and (max-width: 767px) {
    .title-promo h2 {
        font-size: 24px;
    }
    .news-description {
        img{
            width: 100%; height: auto !important;
        }
    }
}
</style>
